var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.exibirPDF)?_c('embed',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.stringPDF}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }